import { Screen } from '../../../../screens/users/activations/download';

export const UsersActivationsDownload: React.FC = () => <Screen />;
